import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/customer/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const customer = {
  get: apiPathFunc(pathBase),
} as const;
